import LegalLayout from "@/components/LegalLayout";

export default function RefundPolicy() {
    return (
        <LegalLayout
            testId="refund-policy-page"
            title="Refund Policy"
            effectiveDate="02-02-2024"
        >
            <p>
                Thank you for choosing FilesCAD! This Refund Policy outlines the terms and conditions under which FilesCAD grants you refunds. By purchasing and downloading digital files from FilesCAD, you agree to abide by the terms set forth in this Refund Policy.
            </p>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">For Regular Purchase</h3>
            <p>
                We have a 48-hour refund policy, which means you have 48 hours after receiving your digital file to request a refund. We will process a refund under the following conditions:
            </p>
            <ul className="list-decimal pl-6 space-y-1">
                <li>If the CNC file is not the same as shown in the photo.</li>
                <li>If the file is not supporting your CNC machines.</li>
                <li>If you find any error in opening the CNC file.</li>
                <li>If the file is corrupted or damaged.</li>
            </ul>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">Refund Process</h3>
            <ul className="list-decimal pl-6 space-y-2">
                <li>Initiate a refund by mailing us a screenshot or payment reference ID of your payment and the problem you encountered related to the design.</li>
                <li>We will review the related design and reply to you within the next 5–6 hours.</li>
                <li>If your problem is genuine, we will try to fix the design file and send it to you again on the same email ID.</li>
                <li>If the related design file is not fixable, we will refund you within the next 48 hours to the same account you purchased the design file from.</li>
            </ul>
            <p>We guarantee the refund within 48 hours if all conditions are met.</p>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">For Membership / Subscription Purchase</h3>
            <p>
                We cannot provide a refund for the membership plan due to the use of digital files. However, if you purchased our Membership/Subscription Plan, we do guarantee you prime customer support where all your questions or problems related to digital files will be solved within 24 hours or earlier.
            </p>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">Contact Us</h3>
            <p>
                To initiate this process, please contact us at:{" "}
                <a
                    href="mailto:support@filescad.com"
                    data-testid="refund-contact-email"
                    className="text-blue-600 hover:underline font-semibold"
                >
                    support@filescad.com
                </a>
            </p>
        </LegalLayout>
    );
}
